// extracted by mini-css-extract-plugin
module.exports = {"form":"Login_form__1zX5V"};